import { PulsarButton } from '@pulsarml/ui.react.components';
import React from 'react';
import { MachineGroupSelectorType } from 'types';
import styles from './index.module.scss';

interface GlobalFilterButtonProps {
  onClick: () => void;
  selectionText: string;
  machineGroups: MachineGroupSelectorType;
}

function GlobalFilterButton(props: GlobalFilterButtonProps) {
  const showNumberOfMachinesSelected =
    props.machineGroups &&
    props.machineGroups.selectedMachines &&
    props.machineGroups.selectedMachines.length > 0;
  return (
    <PulsarButton
      size="large"
      variant="outline"
      colorSet="secondary"
      onClick={props.onClick}
      className="!tw-py-[7px]"
    >
      <div className={styles['button-title']}>
        <span>{props.selectionText}</span>
        {showNumberOfMachinesSelected && (
          <>
            <div className={styles.bar}>|</div>
            <span>{props.machineGroups.selectedMachines.length}</span>
          </>
        )}
      </div>
    </PulsarButton>
  );
}

export default GlobalFilterButton;
